module.exports = __webpack_public_path__ + "static/media/wall-weight-reward.746bd489.gif";